<template>
    <c-dialog ref="dialog" width="750" mode="slide" @resolve="openHandle">
        <c-form ref="form" unit-width="100%">
            <c-form-item label="商户名称" required>
                <c-input name="saas_name" maxlength="50" placeholder="请输入商户名称"></c-input>
            </c-form-item>
            <c-form-item label="商户简码" required tip="请输入3个字符，只能输入数字或英文字母">
                <c-input name="saas_brief_code" maxlength="3" placeholder="请输入商户简码"></c-input>
            </c-form-item>
            <c-form-item label="开通版本" required>
                <c-radio-group name="version_id" :options="versionOptions" :clear="false"></c-radio-group>
            </c-form-item>
            <c-form-item label="授权到期时间" required>
                <c-datetime name="auth_exp_date" type="datetime" format="yyyy-MM-dd hh:mm"></c-datetime>
            </c-form-item>
            <c-form-item label="通联账户类型" required>
                <c-radio-group name="member_type" :options="memberTypeOptions" :clear="false"></c-radio-group>
            </c-form-item>
            <c-form-item label="商户类型" required>
                <c-select name="merchant_type" :options="merchantTypeOptions"></c-select>
            </c-form-item>
            <c-form-item label="线下渠道收款形式" required>
                <c-select name="offline_payment_type" :options="offlinePaymentTypeOptions"></c-select>
            </c-form-item>
            <c-form-item label="最大用户数" tip="当前商户可创建的子账号数量">
                <c-input name="max_account_count" type="stepper" step-controls="side" range="1,500" append-text="个"
                         v-model="max_account_count" :clear="false"></c-input>
            </c-form-item>
        </c-form>
        <div style="padding:0 20px;color:#999;font-size:12px;">
            说明：开通后将自动使用申请人的联系手机作为管理员登录手机号，管理员账号默认为admin，系统将自动生成初始密码。
        </div>
    </c-dialog>
</template>

<script>
export default {
    data() {
        return {
            applyData: null,
            max_account_count: 99,
            versionOptions: [],
            memberTypeOptions: [
                {name: '个人', value: 3, color: 'blue'},
                {name: '企业', value: 2, color: 'green'}
            ],
            merchantTypeOptions: [
                {name: '自营商户', value: 1, color: 'green'},
                {name: '普通商户', value: 2, color: 'blue'}
            ],
            offlinePaymentTypeOptions: [
                {name: '自主收款', value: 1, color: 'green'},
                {name: '分账', value: 2, color: 'blue'}
            ]
        }
    },

    mounted() {
        this.initSaasVersion();
    },

    methods: {
        /*******加载版本下拉框数据*****************/
        initSaasVersion() {
            this.request({
                url: '/sys_saas/version/list',
                data: {},
                success: data => {
                    this.versionOptions = data.map(item => {
                        return {
                            name: item.version_name,
                            value: item.id,
                            data: item
                        }
                    })
                }
            })
        },

        open(data) {
            this.applyData = data;
            this.$refs.form.clear();
            this.max_account_count = 99;
            // 预填商户名称
            this.$refs.form.set({
                saas_name: data.shop_name,
                max_account_count: this.max_account_count
            });
            this.$refs.dialog.open({
                title: '开通商户 - ' + data.shop_name
            });
        },

        openHandle(stop, next) {
            stop();
            this.$refs.form.submit({
                url: '/sys_saas/apply/open',
                rule: {
                    saas_name: '请填写商户名称',
                    saas_brief_code: '请填写商户简码',
                    version_id: '请选择开通版本',
                    auth_exp_date: '请选择授权到期时间',
                    member_type: '请选择通联账户类型',
                    merchant_type: '请选择商户类型',
                    offline_payment_type: '请选择线下渠道收款形式'
                },
                dataFormatter: data => {
                    data.id = this.applyData.id;
                    data.max_account_count = this.max_account_count;
                    return data;
                },
                success: (data, res) => {
                    next();
                    // 显示开通成功信息（包含初始密码）
                    this.$confirm({
                        title: '开通成功',
                        cancelButton: false,
                        message: res || '商户开通成功',
                        resolve: () => {}
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
